// import React from "react";
// import { ChatBox } from "../packages/ffp-chatbox/Chatbox";

// export default function App() {
//   return (
//     <div className="p-4 h-screen">
//       <ChatBox />
//     </div>
//   );
// }

// import './index.scss';
// import './registerChatBox'; 

import React from "react";
import ReactDOM from "react-dom/client";
import { ChatBox } from "../packages/ffp-chatbox/index";
import './index.scss';


function mount(container: HTMLElement) {
  // Get the target element by ID
if (container) {
  const root = ReactDOM.createRoot(container);
  root.render(<ChatBox />);
}
}

(window as any).ffpChatbox = {
  mount,
};
